<template>
  <transition
    :css="false"
    @before-enter="beforeEnter"
    @enter="enter"
    @leave="leave"
  >
    <slot />
  </transition>
</template>

<script>
export default {
  methods: {
    beforeEnter: function (el) {
      el.style.opacity = 0
      el.style.height = 0
    },
    enter: function (el, done) {
      this.gsap.to(el, 0.3, {
        opacity: 1,
        height: 'auto',
        ease: 'ease.out( 1, 0.3)',
        onComplete: done,
      })
    },
    leave: function (el, done) {
      this.gsap.to(el, 0.3, {
        opacity: 0,
        height: 0,
        ease: 'ease.in(1.2, 0.8)',
        onComplete: done,
      })
    },
  },
}
</script>
